// extracted by mini-css-extract-plugin
export default {"container":"IK9LZ","content":"DtWdR"};